export default "__VITE_ASSET__CUfatYvW__"